import dayjs from 'dayjs';

const formattedDate = (date: Maybe<string>): string =>
  dayjs(date ?? '').format('MMMM DD, YYYY');

export default formattedDate;
